document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector(
    '.shopify-section-group-footer-group'
  );

  if (!footer) return;

  const updateFooterHeight = () => {
    const footerContent =
      footer.querySelector('.section-wrapper') || footer;

    const height = footerContent.scrollHeight;

    document.documentElement.style.setProperty(
      '--footer-reveal-height',
      `${height}px`
    );
  };

  updateFooterHeight();

  const resizeObserver = new ResizeObserver(updateFooterHeight);
  resizeObserver.observe(footer);

  window.addEventListener('resize', updateFooterHeight);
});

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('#header-component');
  const hero = document.querySelector('.hero__media');

  if (!header || !hero) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      header.toggleAttribute('data-over-hero', entry.isIntersecting);
    },
    {
      threshold: 0,
      rootMargin: '-60px 0px 0px 0px'
    }
  );

  observer.observe(hero);
});